import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Home.css';
import heroImage from '../assets/chatbot-hero.png';
import logo from '../assets/logo.svg'; // ✅ your SVG path
import documentIcon from '../assets/document.svg';
// React Icons
import { FaFileAlt, FaSearch, FaComments, FaBookOpen, FaBrain, FaChartLine, FaLock } from 'react-icons/fa';

import NeuralBackground from '../components/Shared/NeuralBackground';
import firstNationsEagleBg from '../assets/first_nations_eagle_symbol.png'; // Eagle Symbol

const Home = () => {
  const navigate = useNavigate();
  const isLoggedIn = localStorage.getItem('token');

  return (
    <div className="home-container" style={{
      /* Full Visibility with Text Contrast */
      backgroundImage: `linear-gradient(rgba(15, 23, 42, 0.4), rgba(15, 23, 42, 0.4)), url(${firstNationsEagleBg})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundAttachment: 'fixed'
    }}>
      <NeuralBackground />
      <header className="home-header">
        <div className="logo">
          <img src={logo} alt="NovaCrest Logo" className="logo-img" />
          <span>AI IntelliDoc </span>
        </div>

        <div className="auth-buttons">
          {isLoggedIn ? (
            <button onClick={() => navigate('/dashboard')} className="btn">
              Dashboard
            </button>
          ) : (
            <>
              <button onClick={() => navigate('/login')} className="btn">
                Login
              </button>
              <button onClick={() => navigate('/register')} className="btn btn-secondary">
                Sign Up
              </button>
            </>
          )}
        </div>
      </header>

      <main className="hero-section">
        <div className="hero-text">
          <div className="hero-headline">
            <img src={documentIcon} alt="Document Icon" className="doc-icon" />
            <h2 className="hero-title">AI IntelliDoc Bot That Understands Your Documents</h2>
          </div>
          <p>
            Upload files, ask questions, and get instant, intelligent answers using our AI-powered chatbot built on Retrieval-Augmented Generation (RAG).
          </p>

          <ul className="features-list">
            <li>
              <FaFileAlt className="feature-icon" />
              <div>
                <span className="feature-title">Upload Any File</span>
                PDFs, Word docs, Excel, and more.
              </div>
            </li>
            <li>
              <FaSearch className="feature-icon" />
              <div>
                <span className="feature-title">Deep Search</span>
                Search across your documents with semantic understanding.
              </div>
            </li>
            <li>
              <FaComments className="feature-icon" />
              <div>
                <span className="feature-title">Chat with Context</span>
                AI understands your queries in the context of your data.
              </div>
            </li>
            <li>
              <FaBookOpen className="feature-icon" />
              <div>
                <span className="feature-title">Multi-Document Chat</span>
                Interact with several files at once like a personal assistant.
              </div>
            </li>
            <li>
              <FaBrain className="feature-icon" />
              <div>
                <span className="feature-title">AI with References</span>
                Every answer comes with cited sources within documents.
              </div>
            </li>
            <li>
              <FaChartLine className="feature-icon" />
              <div>
                <span className="feature-title">Save History</span>
                Review past conversations stored locally until logout.
              </div>
            </li>
            <li>
              <FaLock className="feature-icon" />
              <div>
                <span className="feature-title">Secure & Private</span>
                Your data is encrypted and never used to train public models.
              </div>
            </li>
          </ul>

          <button
            onClick={() => navigate(isLoggedIn ? '/chat' : '/register')}
            className="btn btn-primary"
          >
            {isLoggedIn ? 'Go to Chat' : 'Get Started'}
          </button>
        </div>
        <div className="hero-image">
          <img src={heroImage} alt="Chatbot illustration" />
        </div>
      </main>
    </div>
  );
};

export default Home;
